// src/pages/ManageBuyPackage.js
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb, Card, Table, Button } from "@themesberg/react-bootstrap";

// helpers
const fmtBaht = (n) => (Number(n) > 0 ? `฿${Number(n).toLocaleString()}` : "0");
const fmtNum = (n) => Number(n).toLocaleString();

// ===== MOCK: แพ็คเกจ =====
const INITIAL_PACKAGES = [
  { name: "Forever", price: 0.0, users: 100, bills: 1000, branches: 1 },
];

const PackagesTable = ({ rows }) => {
  const RowItem = ({ idx, r }) => (
    <tr>
      <td>{idx}</td>
      <td className="text-start">{r.name}</td>
      <td className="text-start">{fmtBaht(r.price)}</td>
      <td className="text-start">{fmtNum(r.users)}</td>
      <td className="text-start">{fmtNum(r.bills)}</td>
      <td className="text-center">{fmtNum(r.branches)}</td>
      <td className="text-center">
        <div className="d-inline-flex gap-2">
          <Button size="sm" variant="warning" className="text-white">
            แก้ไข
          </Button>
          <Button size="sm" variant="danger">
            ลบ
          </Button>
        </div>
      </td>
    </tr>
  );

  return (
    <Card border="light" className="shadow-sm mb-4">
      <Card.Body className="pb-0">
        <Table responsive className="table-centered table-nowrap rounded mb-0">
          <thead className="thead-light">
            <tr>
              <th className="border-0">รหัส</th>
              <th className="border-0 text-start">ชื่อแพ็คเกจ</th>
              <th className="border-0 text-start">ราคา</th>
              <th className="border-0 text-start">จำนวนผู้ใช้</th>
              <th className="border-0 text-start">จำนวนบิล</th>
              <th className="border-0 text-center">จำนวนสาขา</th>
              <th className="border-0 text-center">จัดการ</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <RowItem key={`pkg-${i}`} idx={i + 1} r={r} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default function ManagePackageSystem() {
  const [packages] = useState(INITIAL_PACKAGES);

  return (
    <>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          />
          <h4>ตั้งค่าแพ็คเกจ</h4>
        </div>
        <div className="btn-toolbar gap-2 mb-2 mb-md-0">
          <Button variant="success">
            <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
            เพิ่มแพ็คเกจ
          </Button>
        </div>
      </div>

      <PackagesTable rows={packages} />
    </>
  );
}
